import React from 'react';
import '../styles/App.css';
import '../styles/Table.css'

/**
 * This class is used to render cvn lists from the SPS2 Info backend when a user submits a part number
 * @author Ethan Jones
 */
class CvnTable extends React.Component{


    /**
     * Iterates through the CVN's in the cvn list and displays them
     * @returns {*}
     */
    renderCvnTable(){
        return(
            <table className={"cvnTable"}>
                <tbody>
                    {this.props.cvnList && this.props.cvnList.map((data, index) => (
                        <tr key={index}>
                            <td>{"CVN: "+data}</td>
                        </tr>
                    ))}
                </tbody>
            </table>)
    }

    /**
     * Main render method for Cvn Table Class
     * @returns {*}
     */
    render(){
        return this.renderCvnTable()
    }
}


export default CvnTable;